import React from 'react';
import strings from "../../../localization";
import { getError, hasError } from "../../../functions/Validation";
import { Button, TextField } from "@material-ui/core";

const PermissionForm = ({
    onSubmit,
    onCancel,
    onChange,
    errors,
    data,
    isDisabled
}) =>{
    return(
        <form id='user-form'>
            <TextField
                label={strings.permissions.category}
                error={hasError(errors, 'category')}
                helperText={getError(errors, 'category')}
                fullWidth
                name='category'
                onChange={onChange}
                margin="normal"
                defaultValue={data.category}
                value={data.category}
                InputLabelProps={{
                    shrink: true,
                }}
                disabled={isDisabled}
                />
            <TextField
                label={strings.permissions.code}
                error={hasError(errors, 'code')}
                helperText={getError(errors, 'code')}
                fullWidth
                name='code'
                onChange={onChange}
                margin="normal"
                defaultValue={data.code}
                value={data.code}
                InputLabelProps={{
                    shrink: true,
                }}
                disabled={isDisabled}
                />

{
                !isDisabled &&
                <div className='submit-container'>
                    <Button variant="contained" color="primary" onClick={onSubmit}>
                        {strings.state.form.ok}
                    </Button>
                    <Button variant="contained" color="secondary" onClick={onCancel}>
                        {strings.state.form.cancel}
                    </Button>
                </div>
            }
        </form>
    )
}
export default PermissionForm;